module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qabdo1-1c4ccc568e4df57b427f2da380bbccd8.jpg";